/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, ShearConnectionPrioritizationDTO } from '../fastAPI.schemas'

/**
 * Return the organisation's shear anchor prioritization per category.
 * @summary Get Organisation Shear Connection Prioritization
 */
export const getOrganisationShearConnectionPrioritization = (signal?: AbortSignal) => {
  return customInstance<ShearConnectionPrioritizationDTO>({
    url: `/shear-connections/prioritization`,
    method: 'GET',
    signal,
  })
}

export const getGetOrganisationShearConnectionPrioritizationQueryKey = () => {
  return [`/shear-connections/prioritization`] as const
}

export const getGetOrganisationShearConnectionPrioritizationQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganisationShearConnectionPrioritization>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrganisationShearConnectionPrioritization>>,
    TError,
    TData
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganisationShearConnectionPrioritizationQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganisationShearConnectionPrioritization>>
  > = ({ signal }) => getOrganisationShearConnectionPrioritization(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganisationShearConnectionPrioritization>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetOrganisationShearConnectionPrioritizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganisationShearConnectionPrioritization>>
>
export type GetOrganisationShearConnectionPrioritizationQueryError = HTTPValidationError

/**
 * @summary Get Organisation Shear Connection Prioritization
 */

export function useGetOrganisationShearConnectionPrioritization<
  TData = Awaited<ReturnType<typeof getOrganisationShearConnectionPrioritization>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrganisationShearConnectionPrioritization>>,
    TError,
    TData
  >
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrganisationShearConnectionPrioritizationQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Overwrite the organisation's prioritized shear anchors per category.
 * @summary Set Organisation Shear Connection Prioritization
 */
export const setOrganisationShearConnectionPrioritization = (
  shearConnectionPrioritizationDTO: ShearConnectionPrioritizationDTO,
) => {
  return customInstance<ShearConnectionPrioritizationDTO>({
    url: `/shear-connections/prioritization`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: shearConnectionPrioritizationDTO,
  })
}

export const useSetOrganisationShearConnectionPrioritizationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setOrganisationShearConnectionPrioritization>>,
    TError,
    { data: ShearConnectionPrioritizationDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof setOrganisationShearConnectionPrioritization>>,
  TError,
  { data: ShearConnectionPrioritizationDTO },
  TContext
> => {
  const mutationKey = ['setOrganisationShearConnectionPrioritization']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setOrganisationShearConnectionPrioritization>>,
    { data: ShearConnectionPrioritizationDTO }
  > = props => {
    const { data } = props ?? {}

    return setOrganisationShearConnectionPrioritization(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/shear-connections/prioritization` },
    {
      operationId:
        'set_organisation_shear_connection_prioritization_shear_connections_prioritization_put',
      operationName: 'setOrganisationShearConnectionPrioritization',
    },
  )

  return customOptions
}

export type SetOrganisationShearConnectionPrioritizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof setOrganisationShearConnectionPrioritization>>
>
export type SetOrganisationShearConnectionPrioritizationMutationBody =
  ShearConnectionPrioritizationDTO
export type SetOrganisationShearConnectionPrioritizationMutationError = HTTPValidationError

/**
 * @summary Set Organisation Shear Connection Prioritization
 */
export const useSetOrganisationShearConnectionPrioritization = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setOrganisationShearConnectionPrioritization>>,
    TError,
    { data: ShearConnectionPrioritizationDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof setOrganisationShearConnectionPrioritization>>,
  TError,
  { data: ShearConnectionPrioritizationDTO },
  TContext
> => {
  const mutationOptions = useSetOrganisationShearConnectionPrioritizationMutationOptions(options)

  return useMutation(mutationOptions)
}
